var store=window.localStorage;

export function setToken(val){
    store.token=val;
}

export function deleteKey(key){
    store.removeItem(key)
}

export function getToken(){
    return store.token;
}
export function setAppId(appId){
    store.report_app_id=appId;
}
export function getAppId(){
    return store.report_app_id;
}

export function checkToken(){
    return store.getItem('UserInfo');
}

export function getUserInfo(){
    let user = store.getItem('UserInfo') || '{"username":\"test\"}';
    //console.log(user);
    return JSON.parse(user);
}

export function setUserInfo(obj){
    return store.setItem('UserInfo', JSON.stringify(obj));
}


export function setBaseUrl(val){
    store.base_url = val;
}

export function getBaseUrl(){
    return store.base_url;
}

export function isMain() {
  let host = store.base_url || ''
  return host.indexOf("gp2.aichatsys.com") > -1 ||
    host.indexOf("admin.rosiechatai.com") > -1;
}

export function setNodeName(val){
    store.node_name = val;
}

export function getNodeName(){
    return store.node_name;
}



// WEBPACK FOOTER //
// ./src/utils/store.js